module.exports = __webpack_public_path__ + "static/media/quickstat.af5d4248.jpeg";